import styled from "styled-components";

export const PageBody = styled.div`
    margin-bottom: 30px;
`;

export const TitlePage = styled.h1`
    text-align: center;
    font-size: 48px;
`;